import { createSelector } from 'reselect'

const getAudienceViewingChart = (state: any) => state.audienceViewingChart

/** A Redux selector to retrieve Live viewer Data
 * @param state - The Redux state
 * @param {object} - Live viewer Data.
 */

export const selectAudienceViewingChart = createSelector(
  getAudienceViewingChart,
  (data) => data && data.audienceViewingChartData ? data.audienceViewingChartData : null
)

